import eventBus from "@/eventBus"
import { EVENT_BUS_EVENTS } from "@/constants/EVENT_BUS_EVENTS"

const catch404 = () => {
  eventBus.$emit(EVENT_BUS_EVENTS.REQUEST_ERROR_CAPTURED, 404)
}

export default catch404
